import { callLambdaApi } from "../callLambdaApi";
import { ApiNames, Methods } from "../constants";

const validIndexes = ['model', 'dataset', 'mlmodel', 'all'];

export class SearchApiCommunicator {

  search(term, index = 'model') {
    console.log("search()");
    if(!validIndexes.includes(index)) {
      throw new Error(`Invalid index: ${index}`);
    }
    return callLambdaApi({
      method: Methods.GET,
      apiName: ApiNames.Submissions,
      path: this._buildBaseURL() + `/${index}?term=${encodeURIComponent(term)}`,
    });
  }

  /**
   * Returns the default serverless api endpoint
   * using the instance's project and model ids.
   * @private
   */
  _buildBaseURL() {
    return `/_search`;
  }
}
